import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { WideLayout } from '../../../../shared/layout/widelayout';
import { usePortalStore } from '../../../../stores/portalStore';
import { useCollectionStore } from '../../../collection/store/collectionStore';
import { useOrderFlowStore } from '../../store/newOrderFlowStore';
import { useRechargeStore } from '../../../recharge/store/rechargeStore';
import { useTechnicalAssistanceStore } from '../../../technical-assistance/store/technicalAssistanceStore';
import { useSalesStore } from '../../../sales/store/salesStore';
import { useSuballocationStore } from '../../../sales/store/suballocationStore';
import { TilesSelection } from '../../components/new-order/tilesSelection';
/**
 *
 * @returns
 */
export const OrderSelectArea = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const currentUser = usePortalStore((state) => state.currentUser);
  const areas = useOrderFlowStore((state) => state.areas);
  const setSelectedArea = useOrderFlowStore((state) => state.setSelectedArea);
  const resetImpl = useOrderFlowStore((state) => state.reset);

  const resetAssistance = useTechnicalAssistanceStore((state) => state.reset);
  const resetCollection = useCollectionStore((state) => state.reset);
  const resetRecharge = useRechargeStore((state) => state.reset);
  const resetSales = useSalesStore((state) => state.reset);
  const resetSuballocation = useSuballocationStore((state) => state.reset);
  const navigate = useNavigate();

  const areaPermissionMap = {
    Implantação: currentUser?.accessImplantacao || currentUser?.isAdmin,
    'Assistência técnica': currentUser?.accessAssistencia || currentUser?.isAdmin,
    Recolhimento: currentUser?.accessRecolhimento || currentUser?.isAdmin,
    // ✅ Recarga: sempre liberada para contas antigas (sem atributo) ou se permissão = true
    Recarga: currentUser?.isAdmin || currentUser?.accessRecarga === true || currentUser?.accessRecarga === undefined || !currentUser?.accessRecarga,
  };

  const filteredAreas = areas.map((area) => {
    if (area.Categoria === 'Descartáveis') {
      return { ...area, disable: !(currentUser?.accessVenda || currentUser?.isAdmin) };
    }
    if (area.Categoria === 'Sublocação') {
      return { ...area, disable: !(currentUser?.accessSubalocacao || currentUser?.isAdmin) };
    }

    const hasPermission = areaPermissionMap[area.Categoria];
    return { ...area, disable: !hasPermission };
  });

  const onClickArea = (area) => {
    if (area.disable) {
      console.warn('Acesso negado para esta área');
      return;
    }

    setSelectedArea({ ...area });
    if (area.Categoria === 'Implantação') {
      resetImpl();
      navigate('/order/selectPatient');
    } else if (area.Categoria === 'Assistência técnica') {
      resetAssistance();
      navigate('/technicalAssistance/assistanceToPatient');
    } else if (area.Categoria === 'Recolhimento') {
      resetCollection();
      navigate('/collectEquipments/collectFromPatient');
    } else if (area.Categoria === 'Recarga') {
      resetRecharge();
      navigate('/recharge/rechargePatient');
    } else if (area.Categoria === 'Descartáveis') {
      resetSales();
      navigate('/sales/selectPatient');
    } else if (area.Categoria === 'Sublocação') {
      resetSuballocation();
      navigate('/suballocation/selectPatient');
    }
  };
  return <WideLayout outlet={<TilesSelection onClickTile={onClickArea} tiles={filteredAreas}></TilesSelection>}></WideLayout>;
};
